import React from 'react';
import { Helmet } from 'react-helmet';
import PropTypes from "prop-types";
import axios from "axios";
import Api from "../../../assets/js/utils/Api.js";
import Auth from "../../../assets/js/utils/Auth.js";
import BackgroundSlider from "../../components/Slider/BackgroundSlider.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import GridContainer from "../../components/Grid/GridContainer.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import userHomePageStyle from "../../../assets/jss/user/userHomePageStyle.jsx";
import ReactTable from "react-table";
import LoaderComponent from '../../components/Loader.js';
import moment from 'moment';
import RefreshIcon from "@material-ui/icons/Refresh";
import Button from "../../components/CustomButtons/Button";

const TextractPayments = class extends React.Component {
    constructor(props){
        super(props);
        this.store = this.props.store;
        this.history = this.props.history;

        this.state = {
            limit: 200,
            response: null,
            loading: false,
            saving: false,
            activeTab: 2,
            page: 1,
            totalPages: 1,
            loadingMore: false,
        }
    }
    componentDidMount(){
        const { authorized } = this.store.getState();
        if(!authorized && !Auth.hasAccessToken()){
            const location = this.history.location;
            const loginRequired = "/auth/login?return="+encodeURIComponent(location.pathname+location.search);
            this.history.push(loginRequired);
        }
        this.loadPayments();
    }
    getTrProps(state, rowInfo){
        return {}
    }
    getTrGroupProps(state, rowInfo){
        if (rowInfo && rowInfo.row) {
            return {
                className: (rowInfo.original.id === 0 ? 'frozen_row' : '')
            }
        }else{
            return {}
        }
    }
    getNoDataProps(){
        return { style: { display: 'none' } };
    }
    getColumns(){
        let columns = [
            {
                Header: "invoice Id",
                accessor: "invoice_id",
                headerClassName: "hd_id",
                className: "hd_id td_id",
            },
            {
                Header: "Payment Date",
                accessor: "created_at",
                headerClassName: "hd_creation_date",
                className: "hd_creation_date td_creation_date",
                sortMethod: (a, b) => {
                    var a1 = new Date(a).getTime();
                    var b1 = new Date(b).getTime();
                    if(a1<b1)
                    return 1;
                    else if(a1>b1)
                    return -1;
                    else
                    return 0;
                }
            },
            {
                Header: "Amount",
                accessor: "amount",
                headerClassName: "hd_amount",
                className: "hd_amounttd_amount",
            },
            {
                Header: "Text Credits",
                accessor: "text_credits",
                headerClassName: "hd_text_credits",
                className: "hd_text_credits td_text_credits",
            },
            {
                Header: "Form Credits",
                accessor: "form_credits",
                headerClassName: "hd_form_credits",
                className: "hd_form_credits td_form_credits",
            },
            {
                Header: "Table Credits",
                accessor: "table_credits",
                headerClassName: "hd_table_credits",
                className: "hd_table_credits td_table_credits",
            },
            {
                Header: "Receipt Credits",
                accessor: "receipt_credits",
                headerClassName: "hd_receipt_credits",
                className: "hd_receipt_credits td_receipt_credits",
            },
        ]

        return columns;
    }
    getTableData(){
        const { response } = this.state;
        if(response === null){
            return [];
        }
        let tableData = [];
        
        response.map(file => {
            let fileArray = {
                invoice_id: file.invoice_id,
                created_at: this.getFormatedDate(file.created_at),
                amount: (<>{file.amount} {file.currency}</>),
                text_credits: file.text_credits,
                form_credits: file.form_credits,
                table_credits: file.table_credits,
                receipt_credits: file.receipt_credits,
            };
            tableData.push(fileArray);
            return null;
        });
        return tableData;
    }
    getFormatedDate(date){
        if(!date || date.length <= 0){
            return "";
        }
        return moment(date).format("MM/DD/YYYY HH:mm:ss");
    }
    loadPayments(viewMore = false){
        const source = axios.CancelToken.source();

        let { page } = this.state;
        if(viewMore){
            page += 1;
        }else{
            page = 1;
        }

        this.setState({
            page: page,
            loading: (!viewMore), 
            loadingMore: viewMore,
            cancelToken: source,
        });

        let requestData = {
            page: page,
            limit: 200,
        };
        
        Api.getTextractPayments(requestData, source).then(data => {
            const oldResponse = (viewMore ? this.state.response:[]);
            const response = oldResponse.concat(data.response);

            this.setState({
                response: response,
                loading: false,
                loadingMore: false,
                totalPages: data.totalPages,
                cancelToken: null
            });
        }).catch(err => {
            if(err && err.message !== "Request Cancelled"){
                this.setState({
                    loading: false,
                    loadingMore: false,
                    cancelToken: null
                })
            }
        });
    }
    renderErrorMessages(){
        const { errorMessage } = this.state;
        if(typeof(errorMessage) === "object"){
            let errorMessages = [];
            let key = 0;
            for(const attrib in errorMessage){
                const message = errorMessage[attrib];
                errorMessages.push(<div key={key} className={"form-error-message passwordCheck-notValid-customizable"}>
                    <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
                    <span className="checkPasswordText-lowerletter">{message}</span>
                </div>);
                key++;
            }
            return errorMessages;
        }
        return <div className={"form-error-message passwordCheck-notValid-customizable"}>
            <span aria-hidden="true" className="validation-error-symbol check-lowerletter">&#x2716;</span>
            <span className="checkPasswordText-lowerletter">{errorMessage}</span>
        </div>;
    }
    onTabChange(urlTab){
        if(urlTab === '0'){
            this.setState({activeTab:0})
            this.history.push("/user/textract");
        }else if(urlTab === '1'){
            this.setState({activeTab:1})
            this.history.push("/user/textract/balance");
        }else if(urlTab === '2'){
            this.setState({activeTab:2})
            this.history.push("/user/textract/payments");
        }
    }
    render() {
        const { classes } = this.props;
        const { limit, loading, activeTab, totalPages, loadingMore, page } = this.state;
        const { authorized } = this.store.getState();
        const tableData = this.getTableData();
        if(!authorized){
            return (
                <div className={classes.main}>
                    <BackgroundSlider store={this.store} />
                    <Helmet>
                        <title>{process.env.REACT_APP_TITLE}</title>
                    </Helmet>
                </div>
            )
        }
        return (
            <div className={classes.main}>
                <div className={classes.container+" "+classes.textractMainContainer}>
                    <div className={classes.content}>
                        <div className={classes.controls}>
                            <GridItem className={classes.controlsTabs}>
                                <div className='sd-custom-tabs'>
                                    <div className={'sd-custom-tab '+(activeTab === 0 ? 'active': '')} onClick={() => this.onTabChange("0")}>
                                        <span>Textract</span>
                                    </div>
                                    <div className={'sd-custom-tab '+(activeTab === 1 ? 'active': '')} onClick={() => this.onTabChange("1")}>
                                        <span>My Balance</span>
                                    </div>
                                    <div className={'sd-custom-tab '+(activeTab === 2 ? 'active': '')} onClick={() => this.onTabChange("2")}>
                                        <span>My Payments</span>
                                    </div>
                                </div>
                            </GridItem>
                            <div className={classes.controlButtons}></div>
                        </div>
                        <GridItem>
                            <div className={classes.textractContainer}>
                                <GridContainer>
                                    <GridItem xs={12}>
                                        <div className='tasks-section'>
                                            <div className='header-section'>
                                                <h5>All My Payments</h5>
                                            </div>
                                            <div className='tasks-table'>
                                                <ReactTable
                                                    columns={this.getColumns()}
                                                    data={tableData}
                                                    pageSizeOptions={[500]}
                                                    defaultPageSize={limit}
                                                    showPaginationTop={false}
                                                    minRows={0}
                                                    showPaginationBottom={false}
                                                    className={"-striped -highlight "+ (loading ? classes.loading : "")+" "+classes.filesTable}
                                                    getTrProps={(state, rowInfo) => this.getTrProps(state, rowInfo)}
                                                    getTrGroupProps={(state, rowInfo) => this.getTrGroupProps(state, rowInfo)}
                                                    getNoDataProps={() => this.getNoDataProps()}
                                                />
                                                {
                                                    loading ?
                                                        <LoaderComponent color="custom" align="center" />
                                                    :
                                                        <></>
                                                }
                                                <div className={classes.loadMore}>
                                                    {
                                                        tableData.length > 0 && loadingMore === false && page < totalPages ?
                                                            <Button color="custom" id="contentViewMore" onClick={(e) => this.loadPayments(true)}>
                                                                <RefreshIcon className={classes.icons} />View More
                                                            </Button>
                                                        :
                                                            loadingMore === true ?
                                                                <LoaderComponent color="custom" align="center" />
                                                            :
                                                                <></>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </GridItem>
                                </GridContainer>
                            </div>
                        </GridItem>
                    </div>
                </div>
                <Helmet>
                    <title>{process.env.REACT_APP_TITLE}</title>
                </Helmet>
            </div>
        )
    }
}

TextractPayments.propTypes = {
    classes: PropTypes.object
};

export default withStyles(userHomePageStyle)(TextractPayments);
